export const state = {
  company: [],
  home: [],
  currentType: null,
};

export const getters = {
  getNewsCompany: state => state.company,
  getNewsHome: state => state.home,
  getCurrentNewsType: state => state.currentType
};

export default {
  state,
  getters
};
